<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Referencias"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="html2Pdf"
      :html-to-pdf-options="options"
    >
      <section slot="pdf-content">
        <div class="pdf-title">Referencias de {{ nombrePersonal || 'DATO NO REGISTRADO' }}</div>
        <v-col cols="12">
          <v-row>
            <v-col cols="12" align="end" class="mr-8">
              <img v-if="photo" :src="photo.src" crossOrigin="anonymous" width="100" height="100" />
              <v-avatar v-else color="secondary" rounded size="50">
                <v-icon size="50" color="white">mdi-account</v-icon>
              </v-avatar>
            </v-col>
          </v-row>
        </v-col>
        <div style="height: 10px"></div>
        <section class="pdf-item" v-for="tipoReferencia in tipoReferencias" :key="tipoReferencia.id">
          <v-container class="font">
            <v-row>
              <v-col cols="12" v-if="filteredReferenciasByTipo(tipoReferencia.id).length > 0">
                <v-row>
                  <v-col cols="12">
                    <div class="text-h5"><strong>TIPO DE REFERENCIA(S): </strong>{{ tipoReferencia.title }}</div>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-col
                        cols="12"
                        v-for="referencia in filteredReferenciasByTipo(tipoReferencia.id)"
                        :key="referencia.idReferencia"
                        class="bordered"
                      >
                        <div><strong>Nombre:</strong> {{ referencia.nombre }}</div>
                        <div><strong>Teléfono:</strong> {{ referencia.telefono }}</div>
                        <template v-if="tipoReferencia.id === 1">
                          <div>
                            <strong>Años de ser vecinos:</strong>
                            {{ referencia.tiempoConocerse || 'DATO NO REGISTRADO' }}
                          </div>
                          <br />
                          <div><strong>DIRECCIÓN:</strong></div>
                          <div style="height: 20px"></div>
                          <v-row class="direccion-section dense-spacing">
                            <v-col cols="12">
                              <v-row dense>
                                <v-col cols="3">Calle: </v-col>
                                <v-col>{{ referencia.calle || 'DATO NO REGISTRADO' }}</v-col>
                              </v-row>
                              <v-row dense>
                                <v-col cols="3">Entre calle: </v-col>
                                <v-col>{{ referencia.entrecalles || 'DATO NO REGISTRADO' }}</v-col>
                              </v-row>
                              <v-row dense>
                                <v-col cols="3">Entre calle 2: </v-col>
                                <v-col>{{ referencia.entrecalles2 || 'DATO NO REGISTRADO' }}</v-col>
                              </v-row>
                              <v-row dense>
                                <v-col cols="3">Número exterior: </v-col>
                                <v-col>{{ referencia.exterior || 'DATO NO REGISTRADO' }}</v-col>
                              </v-row>
                              <v-row dense>
                                <v-col cols="3">Número interior: </v-col>
                                <v-col>{{ referencia.interior || 'DATO NO REGISTRADO' }}</v-col>
                              </v-row>
                              <v-row dense>
                                <v-col cols="3">Colonia: </v-col>
                                <v-col>{{ referencia.colonia || 'DATO NO REGISTRADO' }}</v-col>
                              </v-row>
                              <v-row dense>
                                <v-col cols="3">Código postal: </v-col>
                                <v-col>{{ referencia.cp || 'DATO NO REGISTRADO' }}</v-col>
                              </v-row>
                              <v-row dense>
                                <v-col cols="3">Estado: </v-col>
                                <v-col>
                                  {{ referencia.estado || 'DATO NO REGISTRADO' }}
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col cols="3">Municipio: </v-col>
                                <v-col>
                                  {{ municipioNombre(referencia.fk_idmunicipio) }}
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col cols="3">Localidad: </v-col>
                                <v-col>{{ referencia.localidad || 'DATO NO REGISTRADO' }}</v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </template>
                        <template v-else-if="tipoReferencia.id === 2">
                          <div>
                            <strong>Años de conocerlo:</strong> {{ referencia.tiempoConocerse || 'DATO NO REGISTRADO' }}
                          </div>
                          <div>
                            <strong>¿Cómo lo conoció?:</strong> {{ referencia.comoConocio || 'DATO NO REGISTRADO' }}
                          </div>
                        </template>
                        <template v-else-if="isLaboralTipo(referencia.tipo)">
                          <div><strong>Cargo:</strong> {{ referencia.cargo || 'DATO NO REGISTRADO' }}</div>
                          <div><strong>Corporación:</strong> {{ referencia.corporacion || 'DATO NO REGISTRADO' }}</div>
                          <div>
                            <strong>Tiempo laborado:</strong> {{ referencia.tiempoLaborado || 'DATO NO REGISTRADO' }}
                          </div>
                        </template>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import { TIPO_REFERENCIAS_LABORALES } from '@src/modules/referencias/domain/TIPO_REFERENCIAS'
import { mapGetters } from 'vuex'

export default {
  components: {
    VueHtml2pdf,
  },

  props: {
    referencias: {
      type: Array,
      default: () => [],
    },
    nombrePersonal: {
      type: String,
      default: '',
    },
    personal: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      options: {
        filename: 'Referencias',
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: false,
        },
        jsPDF: {
          unit: 'px',
          format: 'a4',
          orientation: 'portrait',
          hotfixes: ['px_scaling'],
        },
      },
      tipoReferencias: [
        { id: 1, title: 'Vecinal' },
        { id: 2, title: 'Personal' },
        { id: 3, title: 'Laboral' },
      ],
      photo: null,
    }
  },

  computed: {
    ...mapGetters('municipio', ['getMunicipios']),
    ...mapGetters('estado', ['getEstados']),
    municipios() {
      return this.getMunicipios
    },
    estados() {
      return this.getEstados
    },
  },

  methods: {
    generateReport() {
      if (this.personal && this.personal.foto) {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
          this.photo = img
          this.$nextTick(() => {
            this.$refs.html2Pdf.generatePdf()
          })
        }
        img.onerror = () => {
          this.photo = null
          this.$refs.html2Pdf.generatePdf()
        }
        img.src = this.personal.foto
      } else {
        this.photo = null
        this.$refs.html2Pdf.generatePdf()
      }
    },

    isLaboralTipo(tipo) {
      return TIPO_REFERENCIAS_LABORALES.includes(tipo)
    },

    filteredReferenciasByTipo(id_tipo_referencia) {
      if (id_tipo_referencia === 3) {
        // Laborales: incluye todos los tipos laborales
        return this.referencias.filter((referencia) => TIPO_REFERENCIAS_LABORALES.includes(referencia.tipo))
      }
      // Vecinal y Personal
      return this.referencias.filter((referencia) => referencia.tipo === id_tipo_referencia)
    },

    municipioNombre(idMunicipio) {
      const municipio = this.municipios.find((m) => m.id === idMunicipio)
      return municipio ? municipio.nombre : 'DATO NO REGISTRADO'
    },
  },
}
</script>

<style scoped>
.bordered {
  border: 1px solid black;
}
.font {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
}
.pdf-title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-top: 10px;
}
.direccion-section {
  font-size: 12px;
}
.dense-spacing .v-row {
  margin-bottom: 0;
}
.dense-spacing .v-col {
  padding-top: 2px;
  padding-bottom: 2px;
}
</style>
